import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { PlatformContentService } from '../platform-content.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-platform-content',
  templateUrl: './add-platform-content.component.html',
  styleUrls: ['./add-platform-content.component.scss']
})
export class AddPlatformContentComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    title: new FormControl(''),
    slug: new FormControl(''),
    content: new FormControl(''),
    observations: new FormControl(''),
    section_id: new FormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<AddPlatformContentComponent>,
    private platformContentService: PlatformContentService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.platformContentService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const platformContent = {
      title: this.form.get('title')?.value,
      slug: this.form.get('slug')?.value,
      content: this.form.get('content')?.value,
      observations: this.form.get('observations')?.value,
      section_id: this.form.get('section_id')?.value,
    };
    this.platformContentService
      .addPlatformContent(platformContent)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
